import { render, staticRenderFns } from "./produtoComprar.vue?vue&type=template&id=7636112c&"
import script from "./produtoComprar.vue?vue&type=script&lang=js&"
export * from "./produtoComprar.vue?vue&type=script&lang=js&"
import style0 from "./produtoComprar.vue?vue&type=style&index=0&id=7636112c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports